export const translationRu = {
  homeBasic: {
    osibilling: 'eOSI',
    subtitle: 'IT-система, созданная специально для председателей любых форм управления МЖД (ОСИ, УК, КСК, ПСК)',
    description: {
      one: 'Система "eOSI" полностью автоматически, ежемесячно делает начисления жильцам за услуги содержания дома, выставляет счета в банковских кабинетах, ведет учет оплат поквартирно, зачисляет оплаты напрямую на счета МЖД любого банка, в любой момент на любом устройстве отображает реальную текущую задолженность жильцов и полностью избавляет председателя и бухгалтера от ежедневной рутиной работы по сбору средств с жильцов',
      two: 'Система «eOSI» полностью автоматически, ежемесячно делает начисления жильцам по всем услугам ОСИ, выставляет счета в банковских кабинетах, ведет учет оплат поквартирно, зачисляет оплаты напрямую из банка на счета ОСИ, в любой момент отображает реальную текущую задолженность жильцов перед ОСИ и полностью избавляет ОСИ от ежедневной рутиной работы по сбору средств с жильцов'
    },
    services: {
      first: {
        title: 'Биллинг',
        smallTitle: '(Начисления абонентам, платежи через Каспи, работа с должниками)',
        service1: 'Начисления абонентам',
        service2: 'Гибкая настройка тарификации ОСИ',
        service3: 'Интеграция с банками (Каспи, Халык) в онлайн режиме',
        service4: 'Корректировки',
        service5: 'Отчетность перед собственниками',
        service6: 'Автоматизация процессов',
        service7: 'Формирование документов для взыскания просроченной задолженности',
        service8: 'Формирование квитанций',
        service9: 'Работа с любого устройства',
        service10: 'Удобный интерфейс',
        subtitle: 'Цена всего 100 тенге с помещения в месяц!'
      },
      second: {
        title: 'Комплекс - бухгалтерия',
        smallTitle: '(расходы, налоговые и статотчеты, начисления ЗП) + биллинг',
        p1: 'Мы заключили партнерское соглашение с компанией inbuh.kz и теперь можем предложить нашим клиентам полный комплекс бухгалтерских услуг на аутсорсе.',
        p2: 'Наши партнеры',
        p2_1: ', специально для наших клиентов предлагают следующие тарифы:',
        p3: 'Индивидуальный тарифный план по запросу после регистрации',
        p4: 'Услуги биллинга 100 тенге с помещения в месяц.',
        p5: 'Такие выгодные цены доступны любому председателю после регистрации в нашей системе',
        p6: 'Например: 100 квартир + 10 платежных поручений',
        p7: 'Всего',
        p8: 'тенге в месяц!',
        l1: 'до 10 платежных поручений - ',
        l2: 'до 20 платежных поручений - ',
        l3: 'до 40 платежных поручений - '
      }
    }
  },
  homeFeatures: {
    title: 'Что вы получаете ежемесячно',
    feature1: {
      title: 'Начисление оплат',
      description: 'Начисление оплат собственникам в системе «eOSI»'
    },
    feature2: {
      title: 'Гибкая настройка тарификации МЖД',
      description:
        'Возможность гибкой настройки тарификации МЖД ( разные тарифы по этажам, подъездам, типам помещений и тд )'
    },
    feature3: {
      title: 'Интеграция с банком',
      description:
        'Полная интеграция системы с банком ( абонент при оплате видит сумму своих задолженностей по каждому виду взносов, произведенные оплаты мгновенно отображаются в системе )'
    },
    feature4: {
      title: 'Корректировка данных',
      description:
        'Возможность самостоятельно откорректировать все данные ( задолженности, площади, тарифы и тд ) за считанные секунды'
    },
    feature5: {
      title: 'Отчетность',
      description:
        'Отчетность перед собственниками ( при подключении к системе «eOSI» жильцы смогут смотреть информацию по всем своим помещениям, отчетность по должникам и прочую информацию о МЖД )'
    },
    feature6: {
      title: 'Автоматизация процессов',
      description:
        'Полная автоматизация процессов в системе «eOSI» ( подключились к системе «eOSI», полностью сняли с себя заботу о сборе средств с жильцов и получаете возможность заниматься делами дома )'
    },
    feature7: {
      title: 'Формирование документов',
      description: 'Автоматическое формирование документов для взыскания просроченной задолженности с должников'
    },
    feature8: {
      title: 'Удобный интерфейс',
      description: 'Удобный интерфейс электронного кабинета председателя и электронного кабинета собственника помещения'
    },
    feature9: {
      title: 'Работа с любого устройства',
      description: 'Возможность работы с электронным кабинетом с любого устройства'
    },
    feature10: {
      title: 'Формирование квитанций',
      description: 'Возможность по нажатию одной кнопки формировать электронные квитанции жильцам'
    },
    feature11: {
      title: 'Автоматическое начисление пени',
      description:
        'Система автоматически, по всем государственным нормам, на основании ставки рефинансирования делает автоматическое начисление пени на просроченный долг абоненту'
    },
    feature12: {
      title: 'Отчетность перед жильцами',
      description:
        'На основании выписки из Вашего банка, система автоматически сформирует отчет жильцу по форме государственного образца по тратам за прошедший период'
    }
  },
  homeInfo: {
    title: 'Вы получаете',
    osifeature1: 'Полностью автоматическое начисление оплат абонентам',
    osifeature2:
      'Доставку абонентам электронных квитанций и возможность формирования квитанций для самостоятельной печати',
    osifeature3: 'Возможность абонентам производить оплату услуг МЖД через самые популярные банки: Kaspi и Halyk',
    osifeature4:
      'Информацию об оплате абонентов в режиме реального времени и видите актуальную задолженность на текущий момент',
    osifeature5: 'Формирование документов для взыскания долгов абонентов (нотариальные заявления и досудебки)',
    osifeature6: 'Простой и удобный интерфейс электронного кабинета Председателя',
    osifeature7:
      'Формирование ежемесячных отчетов председателя перед собственниками по форме утвержденного, государственного образца',
    osifeature8: 'В скором времени будет реализована возможность формирования налоговой отчетности',
    endTitle1: 'Всего за 100 тенге с помещения в месяц!',
    endTitle2: 'Свыше 1000 квартир действует пониженный тариф, подробности у менеджеров'
  },
  login: {
    notRegistered: 'Не регистрировались',
    passRegistration: 'Пройти регистрацию',
    title: 'Войдите в Кабинет ОСИ',
    phonePlaceholder: 'Введите номер телефона',
    sixDigitsPassword: 'Введите 6-значный пароль',
    registrationNotFinished: 'Регистрация не завершена'
  },
  register: {
    title: 'Регистрация',
    subtitle: 'Пройдите регистрацию для входа в Кабинет ОСИ',
    offer: 'Регистрируясь, я подтверждаю что ознакомлен с',
    alreadyRegistered: 'Регистрировались ранее',
    conditions: 'условиями оферты',
    polite: 'политикой безопасности',
    continueRegister: 'Для продолжения регистрации пройдите по ссылке'
  },
  signer: {
    storage: 'Хранилище',
    sign: 'Подписать ЭЦП',
    dialogTite: 'Подпись документа ЭЦП',
    dialogContent:
      'Подписывая документ с помощью ЭЦП, Вы подтверждаете корректность введеных данных и предоставленных документов',
    notConnectToNCAlayer: 'Нет подключения к NcaLayer',
    ncaLayerError: 'Ошибка NCLayer',
    // OSI-763: раньше отмена в окне NCALayer никак не показывалась пользователю
    signCancelled: 'Подписание отменено',
    signError: 'Не удалось подписать документ',
    needSignNewDoc:
      'В связи с переименованием компании с "OSI Billing" на "eosi.kz" необходимо заново подписать оферту по средством ЭЦП. По возникшим вопросам обращаться на номер +77076825676 Максим',
    fetchDocError: 'Ошибка при получении договора'
  },
  resetPassword: {
    title: 'Забыли пароль?',
    subtitle: 'Пожалуйста, введите номер телефона и мы вышлем Вам код для сброса пароля',
    sixDigitCodeTG: 'Введите 6-значный код из Телеграм-бота'
  },
  roles: {
    title: 'Войти как',
    abonent: 'Абонент',
    chairman: 'Председатель',
    trusted: 'Доверенный',
    // Карточка роли в боковом меню, когда роль не выбрана, и пункт меню аватара
    // (дефект «сброс роли на ABONENT после очистки сессии»)
    selectRole: 'Выберите роль',
    changeRole: 'Сменить роль'
  },
  cabinetRoot: {
    appList: 'Список заявок',
    subtitle: 'Если Вы являетесь председателем ОСИ, подайте заявку на регистрацию',
    sendOrder: 'Подать заявку',
    registrationListHeader: 'Заявки на регистрацию ОСИ',
    registrationTable: {
      created: 'Создана',
      state: 'Состояние',
      name: 'Наименование',
      IDN: 'БИН',
      address: 'Адрес'
    },
    findOsi: 'Поиск ОСИ',
    osiViewCarousel: 'Карусель',
    osiViewGrid: 'Сетка',
    // OSI-806: состояние «поиск ОСИ не дал результата».
    // {query} — ICU-плейсхолдер поискового запроса, <b> — rich-text тег react-intl (см. Osis).
    osiNotFound: 'Не найдено',
    osiNotFoundHint: 'Нет результата по поиску <b>"{query}"</b>. Попробуйте другое значение для поиска.',
    user: {
      title: 'Профиль пользователя',
      main: 'Основное',
      changePassword: 'Смена пароля',
      oldPassword: 'Старый пароль',
      newPassword: 'Новый пароль',
      repeatNewPassword: 'Повторите новый пароль',
      navigation: {
        home: 'Домой',
        profile: 'Профиль пользователя'
      }
    },
    registration: {
      title: 'Регистрация ОСИ',
      homeLink: 'Домой',
      view: 'Просмотр заявки',
      re: 'Регистрация ОСИ',
      step1: 'Регистрационные данные',
      step2: 'Документы',
      step3: 'Подтверждение'
    }
  },
  osiRoot: {
    breadcrumbs: {
      begin: 'Начало'
    },
    navBarHeader: 'КАБИНЕТ ОСИ',
    osiInfo: 'Сведения о доме',
    osiServices: 'Тех. карта ОСИ',
    osiAbonents: 'Помещения / Квартиры',
    osiAccurals: 'Начисления платежей',
    osiOsv: 'Сальдо',
    osiPayments: 'Платежи',
    // OSI-814: раздел переименован из «Бухгалтерские документы» (бух. документы станут отдельной категорией)
    osiActs: 'Акты выполненных работ',
    osiReports: 'Отчеты',
    osiDebts: 'Уведомления должникам',
    osiInvoices: 'Квитанции',
    osiForum: 'Он-лайн собрание',
    osiInspection: 'Уведомления жилищной испекции'
  },
  osiInfo: {
    mainInfo: {
      tabTitle: 'Основные данные',
      title: 'Основные данные',
      docs: 'Документы',
      electro: 'Электроснабжение собственное',
      hotWater: 'Собственная горячая вода',
      heating: 'Собственное отопление',
      gasified: 'Газифицирован'
    },
    bills: {
      tabTitle: 'Счета',
      title: 'Счета',
      addBill: 'Добавление счета',
      deleteBill: 'Удаление счета',
      editBill: 'Редактирование счета',
      table: {
        billType: 'Тип счета',
        bill: 'Счет',
        IDNBank: 'БИК Банка'
      }
    },
    companies: {
      tabTitle: 'Сервисные компании',
      title: 'Сервисные компании',
      addCompany: 'Добавление сервисной компании',
      deleteCompany: 'Удаление сервисной компании',
      editCompany: 'Изменение сервисной компании',
      table: {
        type: 'Тип',
        phones: 'Телефоны',
        address: 'Адреса',
        print: 'Печатать в квитанции'
      }
    },
    trustedUsers: {
      tabTitle: 'Доверенные пользователи'
    }
  },
  osiAbonents: {
    addFlat: 'Добавить помещение/квартиру',
    editing: 'Редактирование',
    table: {
      number: 'Номер',
      personalAcc: 'ЛС ОСИ',
      ercAcc: 'ЛС ЕРЦ',
      square: 'Площадь',
      effectiveSquare: 'Полезная площадь',
      floor: 'Этаж',
      name: 'Собственник',
      owner: 'Владелец',
      idn: 'БИН/ИИН',
      phone: 'Телефон',
      type: 'Тип',
      livingFact: 'Проживает',
      livingJur: 'Зарегистрировано'
    },
    totalSquare: 'Общая площадь',
    totalRows: 'Всего строк'
  },
  osiAccruals: {
    tabs: {
      plan: 'План начислений',
      saldo: 'Начальное сальдо абонентов'
    },
    serviceStatuses: {
      ready: 'Готово',
      notReady: 'Не готова',
      inactive: 'Не активна'
    },
    serviceErrors: {
      emptyTariff: 'Не указана сумма тарифа',
      emptyAbonents: 'Не выбраны помещения для начислений по услуге'
    },
    formElements: {
      editFormTitle: 'Редактирование услуги',
      deleteFormTitle: 'Удаление услуги из плана начислений',
      addFormTitle: 'Добавление услуги в план начислений',
      customServiceFormTitle: 'Создание услуги',
      name: 'Наименование'
    },
    abonentsSelected: 'Подключено к услуге',
    pageTitle: 'План начислений',
    table: {
      number: 'Номер помещения',
      owner: 'Собственник помещения',
      saldo: 'Сальдо',
      status: 'Статус',
      service: 'Услуга',
      tariff: 'Тариф',
      abonents: 'Абоненты',
      type: 'Тип',
      flat: 'Помещение',
      floor: 'Этаж',
      square: 'Площадь',
      parkingPlaces: 'Парковочные места',
      residential: 'Жилые',
      nonResidential: 'Нежилые',
      basement: 'Подвал',
      parking: 'Паркинг',
      storage: 'Кладовки'
    }
  },
  osiOSV: {
    // подпись чекбокса схлопывания дочерних помещений (паркинги/кладовки) в родителя
    collapseChildren: 'Свернуть дочерние помещения',
    tabs: {
      osi: 'ОСИ',
      flats: 'Помещения',
      accruals: 'Начисления',
      paymentOrders: 'Свод платежных поручений'
    },
    pageTitle: 'Оборотно-сальдовая ведомость',
    table: {
      number: '№ помещения',
      abonentName: 'ФИО собственника',
      owner: 'Владелец',
      totalBegin: 'Сальдо на начало',
      totalDebt: 'Начислено',
      totalFixes: 'Корректировки',
      totalKredit: 'Оплачено',
      totalFine: 'Пеня',
      totalEnd: 'Долг',
      period: 'Период',
      service: 'Услуга',
      total: 'Общая сумма',
      footer: {
        startOsv: 'Сальдо на начало:',
        accrued: 'Начислено:',
        fixes: 'Корректировки:',
        payed: 'Оплачено:',
        // OSI-808: подпись пени в футере ОСВ и подпись строки «ИТОГО» закреплённых строк итогов
        fine: 'Пеня:',
        debt: 'Долг:',
        total: 'ИТОГО',
        // OSI-808: подписи кнопки сворачивания/разворачивания строк итогов по категориям услуг
        showCategories: 'Показать по категориям',
        hideCategories: 'Скрыть категории'
      }
    }
  },
  osiPayments: {
    tabs: {
      payments: 'Платежи',
      corrections: 'Корректировки'
    },
    pageTitle: 'Платежи',
    formElements: {
      createPayment: 'Создать платёж',
      createCorrection: 'Создать корректировку'
    },
    table: {
      date: 'Дата платежа',
      acceptedBank: 'Принят',
      abonentName: 'Собственник помещения',
      number: 'Номер помещения',
      service: 'Услуга',
      amount: 'Сумма\u00a0(тенге)',
      reason: 'Назначение'
    }
  },
  osiActs: {
    signedDocs: 'Подписанные документы',
    unsignedDocs: 'Документы на подпись',
    actions: {
      sign: 'Подписать',
      watch: 'Просмотр'
    },
    signAcceptContent: 'Подписывая документ с помощью ЭЦП, Вы подтверждаете корректность предоставленных данных'
  },
  osiDebts: {
    tabs: {
      debts: 'Задолженности предыдущих периодов',
      docs: 'Образцы документов'
    },
    newDebt: {
      buttonLabel: 'Внести задолженность',
      title: 'Внесение задолженности предыдущих периодов',
      startSaldoPeriod: 'Начальное сальдо на период "',
      acceptChanged: 'Подтверждаете изменение в системе начального сальдо',
      saldoNotMatch: 'Начальное сальдо по услуге не совпадает с долгом на конец периода "'
    },
    docs: {
      debt: 'Уведомление должнику',
      notary: 'Уведомление нотариусу'
    },
    table: {
      number: '№ помещения',
      abonent: 'ФИО абонента',
      serviceGroup: 'Группа услуг',
      amount: 'Задолженность за период, тг.',
      period: 'Период'
    }
  },
  osiInvoices: {
    tabs: {
      invoices: 'Квитанции',
      qr: 'QR код',
      // Вкладка «Квитанции предыдущих периодов» в ЛК жителя
      pastInvoices: 'Квитанции предыдущих периодов'
    },
    // Подпись селектора периода (месяц+год) на вкладке «Квитанции предыдущих периодов»
    period: 'Период',
    table: {
      title: 'Выбор абонентов для формирования квитанции',
      flat: 'Помещение',
      owner: 'Собственник',
      areaType: 'Тип',
      id: 'ЛС ОСИ',
      square: 'Площадь'
    },
    createInvoices: 'Сформировать все квитанции',
    createPartialInvoices: 'Сформировать отдельные квитанции',
    create: 'Сформировать',
    invoiceConstraints: 'Формирование квитанций доступно с 5 по последнее число текущего месяца.',
    createQR: 'Создать QR',
    telegramBot: 'Бот eOSI.kz',
    telegramLinkHeader: 'Уважаемые председатели, скопируйте текст ниже и отправьте его в чат дома.',
    telegramLinkInfo1:
      'Уважаемые жильцы, для вашего удобства появилась возможность получения электронных квитанций! Для этого необходимо перейти по ссылке: ',
    telegramLinkInfo2:
      ' и ввести номер квартиры! После этого Вы ежемесячно будете получать актуальные квитанции, которые будут доступны в любое время в вашем телефоне!',
    videoInfo: 'Видео по получению электронных квитанций:',
    fetchQRError: 'Ошибка при получении QR кода'
  },
  osiReports: {
    tabs: {
      systemReports: 'Системные отчеты',
      accountReports: 'Отчеты перед жильцами'
    },
    pageTitle: 'Отчеты',
    table: {
      name: 'Название отчета',
      comment: 'Комментарий'
    },
    dialogs: {
      selectPeriod: 'Выберете период'
    },
    reports: {
      debts: {
        name: 'Отчет по должникам',
        comment:
          'Данный отчет включает просроченные долги на данный момент. Долг считается просроченным с 26 числа текущего месяца.'
      }
    },
    fetchReportError: 'Ошибка при получении отчета'
  },
  osiWizard: {
    notification:
      'У вас не заполнена информация по квартирам. Введите данные нажав на значок карандаша слева от каждой квартиры.',
    steps: {
      step1: 'Сведения об ОСИ',
      step2: 'Сервисные компании',
      step3: 'Помещения',
      step4: 'Счета',
      step5: 'План начислений',
      step6: 'Начальное сальдо абонентов'
    }
  },
  osiRegistration: {
    holdForDelete: 'Удерживайте для удаления',
    dragAndDropText: 'Прикрепите файл из приложения/сайта банка с реквизитами счета'
  },
  common: {
    formFields: {
      fio: {
        label: 'ФИО',
        validation: {
          need: 'Укажите ФИО'
        }
      },
      osiName: {
        label: 'Наименование',
        validation: {
          need: 'Укажите наименование'
        }
      },
      IDNOSI: {
        label: 'БИН / ИИН',
        validation: {
          need: 'Укажите БИН / ИИН',
          tooShort: 'БИН / ИИН указан не полностью',
          error: 'БИН / ИИН указан не верно'
        }
      },
      fioChairman: {
        label: 'ФИО Председателя',
        validation: {
          need: 'Укажите ФИО Председателя'
        }
      },
      iin: {
        label: 'БИН / ИИН',
        validation: {
          tooShort: 'БИН / ИИН указан не полностью',
          error: 'БИН / ИИН указан не верно',
          need: 'Укажите БИН'
        }
      },
      phone: {
        label: 'Контактный телефон',
        validation: {
          tooShort: 'Номер указан не полностью',
          error: 'Номер указан не верно',
          need: 'Укажите контакный телефон'
        }
      },
      email: {
        label: 'Email',
        validation: {
          error: 'Укажите правильный Email'
        }
      },
      constructionYear: {
        label: 'Год постройки',
        validation: {
          need: 'Укажите год постройки',
          min: 'Минимальный год постройки 1800',
          max: 'Максимальный год постройки текущий'
        }
      },
      constructionMaterial: {
        label: 'Тип дома',
        validation: {
          need: 'Укажите тип дома'
        }
      },
      houseState: {
        label: 'Состояние дома',
        validation: {
          need: 'Укажите состояние дома'
        }
      },
      floorCount: {
        label: 'Количество этажей',
        validation: {
          need: 'Укажите количество этажей',
          error: 'Укажите верно этаж',
          max: 'Максимально 100 этажей'
        }
      },
      number: {
        label: 'Номер',
        validation: {
          need: 'Укажите номер'
        }
      },
      flatType: {
        label: 'Тип помещения',
        validation: {
          need: 'Укажите тип помещения'
        }
      },
      parentAbonent: {
        label: 'Родительское помещение',
        validation: {
          need: 'Для парковочного места и кладовки обязательна привязка к родительскому помещению'
        }
      },
      flat: {
        label: 'Помещение',
        validation: {
          need: 'Укажите помещение'
        }
      },
      floor: {
        label: 'Этаж',
        validation: {
          need: 'Укажите этаж'
        }
      },
      square: {
        label: 'Площадь',
        validation: {
          need: 'Укажите площадь'
        }
      },
      effectiveSquare: {
        label: 'Полезная площадь',
        validation: {
          need: 'Укажите полезную площадь'
        }
      },
      owner: {
        label: 'Собственник',
        labelAlt: 'Владелец',
        validation: {
          need: 'Укажите собственника'
        }
      },
      service: {
        label: 'Услуга',
        validation: {
          need: 'Укажите услугу'
        }
      },
      accrualType: {
        label: 'Метод начисления услуги',
        validation: {
          need: 'Укажите метод начисления услуги'
        }
      },
      tariff: {
        label: 'Тариф',
        validation: {
          need: 'Укажите тариф',
          positive: 'Значение должно быть больше 0'
        }
      },
      arendator: {
        label: 'Арендатор',
        validation: {
          need: 'Укажите арендатора'
        }
      },
      month: {
        label: 'Месяц',
        validation: {
          need: 'Укажите месяц'
        }
      },
      fromMonth: {
        label: 'С месяца',
        validation: {
          need: 'Укажите месяц'
        }
      },
      toMonth: {
        label: 'по месяц (включительно)',
        validation: {
          need: 'Укажите месяц'
        }
      },
      selectFlat: {
        label: 'Выбор помещения',
        validation: {
          need: 'Укажите выбор помещения'
        }
      },
      selectNotify: {
        label: 'Выбор уведомления',
        validation: {
          need: 'Выберите уведомление'
        }
      },
      fromDate: {
        label: 'С',
        validation: {
          need: 'Укажите с даты'
        }
      },
      toDate: {
        label: 'По',
        validation: {
          need: 'Укажите по дату'
        }
      },
      serviceGroup: {
        label: 'Группа услуг',
        validation: {
          need: 'Укажите группу услуг'
        }
      },
      room: {
        label: 'Помещение',
        validation: {
          need: 'Укажите помещение'
        }
      },
      sum: {
        label: 'Сумма',
        validation: {
          need: 'Укажите сумму'
        }
      },
      reason: {
        label: 'Назначение',
        validation: {
          need: 'Укажите назначение',
          min: 'Укажите назначение подробнее'
        }
      },
      paymentDate: {
        label: 'Дата платежа',
        validation: {
          need: 'Укажите дату платежа'
        }
      },
      name: {
        label: 'Наименование',
        validation: {
          need: 'Укажите наименование'
        }
      },
      monthSum: {
        label: 'Сумма за месяц, тг',
        validation: { need: 'Укажите сумму за месяц' }
      },
      address: {
        label: 'Адрес',
        validation: { need: 'Укажите адрес' }
      },
      ats: {
        label: 'Населенный пункт',
        validation: { need: 'Укажите населенный пункт' }
      },
      geonim: {
        label: 'Улица',
        validation: { need: 'Укажите улицу' }
      },
      building: {
        label: 'Строение',
        validation: { need: 'Укажите строение' }
      },
      livingFact: {
        label: 'Проживает'
      },
      livingJur: {
        label: 'Зарегистрировано'
      },
      flatCount: {
        label: 'Количество помещений',
        validation: {
          tooShort: 'Укажите не менее 2 помещений',
          tooBig: 'Укажите меньшее число',
          need: 'Укажите количество помещений/квартир'
        }
      },
      unionType: {
        label: 'Вид объединения',
        validation: {
          need: 'Укажите вид объединения'
        }
      },
      companyType: {
        label: 'Тип компании',
        validation: {
          need: 'Укажите тип компании'
        }
      },
      billType: {
        label: 'Тип счета',
        validation: {
          need: 'Укажите тип счета'
        }
      },
      bill: {
        label: 'Основной расчетный счет',
        validation: {
          need: 'Укажите номер счета',
          tooShort: 'Счет указан не полностью',
          error: 'Счет указан не верно'
        }
      },
      IDNBank: {
        label: 'БИК Банка',
        validation: {
          need: 'Укажите БИК банка',
          tooShort: 'БИК банка указан не полностью',
          error: 'БИК банка указан не верно'
        }
      }
    },
    registration: 'Регистрация',
    register: 'Зарегистрироваться',
    login: 'Войти',
    copyright: 'Все права защищены',
    settings: 'Настройки',
    theme: 'Тема',
    color: 'Цвет',
    size: 'Размер',
    language: 'Язык',
    fullScreen: 'На весь экран',
    standard: 'Стандартно',
    back: 'Назад',
    rememberMe: 'Запомнить меня',
    forgetPassword: 'Забыли пароль',
    check: 'Проверить',
    menu: 'Меню',
    welcome: 'Добро пожаловать',
    save: 'Сохранить',
    exit: 'Выход',
    myProfile: 'Мой профиль',
    add: 'Добавить',
    download: 'Скачать',
    total: 'Всего',
    cancel: 'Отменить',
    delete: 'Удалить',
    accepted: 'Согласен',
    close: 'Закрыть',
    begin: 'Начало',
    refresh: 'Обновить',
    select: 'Выбрать',
    print: 'Печать',
    next: 'Далее',
    finish: 'Завершить',
    empty: 'Отсутствуют',
    howToUse: 'Инструкция к заполнению',
    clickMe: 'Нажми на меня',
    filled: 'Заполнено',
    finesSwitch: 'Включить начисление пени',
    success: 'Успешно'
  }
};
